import React, { useEffect, useState } from 'react';
import { Button, Link, MessagePlugin, Popconfirm, Space, Table } from 'tdesign-react';
import { cloneDeep, findIndex, isEmpty, isNil } from 'lodash';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { fetchComponentList } from '@/slices/templateSlice';
import VariableModal from '@/pages/Maintenance/Template/components/VariableModal';
import { isVoid } from '@/utils/common';

function Variable({ onChange, value, fetchComponentList, original, variableLevel }) {
  const [visible, setVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [rowIndex, setRowIndex] = useState();

  useEffect(() => {
    fetchComponentList({ startIndex: 1, pageSize: 99999 });
  }, [fetchComponentList]);

  const columns = [
    {
      colKey: 'key',
      title: '变量key',
      width: 160,
    },
    {
      colKey: 'label',
      title: '显示名称',
      width: 150,
    },
    {
      colKey: 'desc',
      title: '变量说明',
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row, rowIndex }) => (
        <Space>
          <Link
            theme='primary'
            onClick={() => {
              setCurrentRow(row);
              setRowIndex(rowIndex);
              setVisible(true);
            }}
            hover='color'
          >
            编辑
          </Link>
          <Popconfirm
            theme='danger'
            content='确定删除？'
            onConfirm={() => handleDel(row, rowIndex)}
          >
            <Link theme='danger' hover='color'>
              移除
            </Link>
          </Popconfirm>
        </Space>
      ),
      width: 110,
    },
  ];

  const handleDel = (row, rowIndex) => {
    const array = cloneDeep(value || []);
    array.splice(rowIndex, 1);
    onChange(array);
  };

  const handleClose = (val) => {
    const array = cloneDeep(value || []);
    if (val) {
      const { id, ...others } = val;
      const _val = {
        ...currentRow,
        ...others,
        varId: val.id,
        label: val.keyName,
      };
      if (findIndex(array, { key: _val.key }) > -1) {
        MessagePlugin.warning('变量已存在，请勿重复添加');
        return;
      }
      // 修改
      if (!isNil(rowIndex)) {
        array.splice(rowIndex, 1, _val);
        onChange(array);
      } else {
        onChange(array.concat(_val));
      }
    }
    setVisible(false);
    setCurrentRow(null);
    setRowIndex(null);
  };

  const addParam = () => {
    if (isVoid(original)) {
      MessagePlugin.warning('请先选择脚本来源');
      return;
    }
    setVisible(true);
  };

  return (
    <Root>
      <Button variant='outline' onClick={addParam}>
        添加变量
      </Button>

      {isEmpty(value) ? null : (
        <Table maxHeight='calc(100vh - 600px)' data={value} columns={columns} />
      )}
      <VariableModal
        scopeType={original}
        variableLevel={variableLevel}
        id={currentRow?.varId}
        visible={visible}
        handleClose={handleClose}
      />
    </Root>
  );
}

export default connect(null, {
  fetchComponentList,
})(Variable);

const Root = styled.div`
  flex: 1;
  width: 0;
  .t-table {
    margin: 28px -70px 26px -140px;
    width: auto;
  }
`;
